import styled from "@emotion/styled";
import { Button, useMediaQuery, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import { useWeb3React } from "@web3-react/core";
import React, { useEffect, useState } from "react";
import { leftArrow } from "../../../assets";
import { NftCard } from "../../../components/NftCard";
import { NoData } from "../../../components/NoData";
import { BORROWED, CLAIMABLE, IN_INVENTORY } from "../../../constants";
import { borrowNFT } from "../../../contract";
import { useAPIActions, useUIActions } from "../../../hooks/useActions";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import { tokens } from "../../../theme";
import { Collectible } from "./Collectible";
import { SearchAndView } from "./SearchAndView";
import { StatusTab } from "./StatusTab";
import TableView from "./TableView";

const StyledButton = styled(Button)(({ theme, colors }) => ({
  backgroundColor: colors.whiteAccent[900],
  color: colors.primary[500],
  fontSize: "14px",
  fontWeight: 400,
  width: "272px",
  height: "40px",
  borderRadius: "7px",
  borderColor: colors.primary[500],
  marginLeft: "20px",
  "&:hover": {
    backgroundColor: colors.primary[600],
    borderColor: colors.primary[500],
    color: colors.whiteAccent[900],
  },
}));

export const OwnedAndClaimable = ({
  profileNfts,
  setProfileNfts,
  setNftStaesOnSelect,
  selectedNft,
  setStep,
  setOperation,
  view,
  setView,
  currStatus,
  setCurrStatus,
  collapsed,
  innerStepper,
  setInnerStepper,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { account, chainId } = useWeb3React();
  const { setLoading, setSnackbar } = useUIActions();
  const { updateClaimableNfts, updateBorrowedNfts } = useAPIActions();
  const { borrowedNfts } = useTypedSelector((state) => state.apiReducer);
  const downXl = useMediaQuery(theme.breakpoints.down("xl"));
  const downMd = useMediaQuery(theme.breakpoints.down("md"));
  const NftBoxProps = () => {
    if (downMd && !collapsed) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(10, 1fr)",

        gap: "30px",
      };
    } else if (downMd) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(15, 1fr)",
        gap: "30px",
      };
    } else if (downXl && !collapsed) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(15, 1fr)",
        gap: "30px",
      };
    } else if (downXl || !collapsed) {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(20, 1fr)",
        gap: "30px",
      };
    } else {
      return {
        display: "grid",
        gridTemplateColumns: "repeat(25, 1fr)",
        gap: "30px",
      };
    }
  };

  const { collectionWiseProfileNfts } = useTypedSelector(
    (state) => state.apiReducer
  );
  const [collections, setCollections] = useState(collectionWiseProfileNfts);
  const [searchVar, setSearchVar] = useState("");
  const [searchShow, setSearchShow] = useState(false);
  const [filteredCollections, setFilteredCollections] = useState([]);
  const [filteredNfts, setFilteredNfts] = useState([]);

  useEffect(() => {
    setCollections(collectionWiseProfileNfts);
  }, [collectionWiseProfileNfts]);

  const claimCallback = async (msg, status) => {
    setLoading(false);
    if (status) {
      setSnackbar({
        open: true,
        severity: "success",
        message: msg,
      });
      const lendingIds = selectedNft.map((nft) => nft.lendingId);
      await updateClaimableNfts(lendingIds, profileNfts);
      const updatedClaimable = profileNfts.filter(
        (nft) => !lendingIds.includes(nft.lendingId)
      );
      setProfileNfts(updatedClaimable);
      await updateBorrowedNfts(selectedNft, borrowedNfts, chainId);
    } else {
      setSnackbar({
        open: true,
        severity: "error",
        message: msg,
      });
    }
  };

  const onClaim = async () => {
    try {
      setLoading(true);
      console.log("selectedNfts", selectedNft);
      const lendingIds = selectedNft.map((nft) => nft.lendingId);
      await borrowNFT(lendingIds, account, claimCallback);
    } catch (e) {
      console.log("error on claim", e);
      setLoading(false);
    }
  };

  if (innerStepper === 0 && currStatus === IN_INVENTORY) {
    return (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          paddingBottom: "20px",
          // border: "1px solid red",
        }}
        gap="10px"
      >
        <SearchAndView
          view={view}
          setView={setView}
          option={false}
          searchVar={searchVar}
          setFiltered={(e) => {
            const { value } = e.target;
            setSearchVar(value);
            if (value === "") {
              setSearchShow(false);
              setFilteredCollections([]);
            } else {
              const filtered = collections.filter((coll) =>
                coll.contractMetadata.name
                  .toLowerCase()
                  .includes(value.toLowerCase())
              );

              setFilteredCollections(filtered);
              setSearchShow(true);
            }
          }}
        />

        <StatusTab currStatus={currStatus} setCurrStatus={setCurrStatus} />
        {searchShow && filteredCollections.length > 0 ? (
          filteredCollections.map((collection) => (
            <Collectible
              collectionName={collection.contractMetadata.name}
              collectionAddress={collection.address}
              totalNfts={collection.nfts.length}
              nfts={collection.nfts}
              setInnerStepper={setInnerStepper}
              setSearchVar={setSearchVar}
              setSearchShow={setSearchShow}
            />
          ))
        ) : searchShow && filteredCollections.length === 0 ? (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <NoData text="No Collections to show!" />
          </Box>
        ) : collections.length > 0 ? (
          collections.map((collection) => (
            <Collectible
              collectionName={collection.contractMetadata.name}
              collectionAddress={collection.address}
              totalNfts={collection.nfts.length}
              nfts={collection.nfts}
              setInnerStepper={setInnerStepper}
            />
          ))
        ) : (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <NoData text="No Collections to show!" />
          </Box>
        )}

        <Box
          display="flex"
          flexDirection="row"
          width="97%"
          marginBottom="10px"
          marginTop="50px"
          alignItems={"center"}
          justifyContent={"center"}
          pl={1}
          visibility={currStatus === BORROWED ? "hidden" : "visible"}
        >
          <StyledButton
            onClick={() => {
              if (currStatus === IN_INVENTORY) {
                setStep(1);
                setOperation("bulk-transfer");
              } else if (currStatus === CLAIMABLE) {
                onClaim();
              }
            }}
            variant="outlined"
            colors={colors}
            disabled={selectedNft.length === 0}
          >
            {currStatus === IN_INVENTORY ? "Send" : "Claim"}
          </StyledButton>
        </Box>
      </Box>
    );
  }

  if (innerStepper !== 0 && currStatus === IN_INVENTORY) {
    return (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          paddingBottom: "20px",
        }}
        gap="10px"
      >
        <SearchAndView
          view={view}
          setView={setView}
          searchVar={searchVar}
          setFiltered={(e) => {
            const { value } = e.target;
            setSearchVar(value);
            if (value === "") {
              setSearchShow(false);
              setFilteredNfts([]);
            } else {
              const filtered = profileNfts.filter((nft) =>
                nft.name.toLowerCase().includes(value.toLowerCase())
              );

              setFilteredNfts(filtered);
              setSearchShow(true);
            }
          }}
        />

        <StatusTab currStatus={currStatus} setCurrStatus={setCurrStatus} />

        {currStatus === IN_INVENTORY && (
          <img
            src={leftArrow}
            alt="left arrow"
            style={{ margin: "15px", cursor: "pointer" }}
            onClick={() => {
              setInnerStepper(0);
              setSearchShow(false);
              setSearchVar("");
            }}
          />
        )}

        {searchShow && filteredNfts.length > 0 ? (
          view === "gallery" ? (
            <Box {...NftBoxProps()}>
              {filteredNfts.map((item, index) => (
                <Box gridColumn="span 5" gridRow="span 3">
                  <NftCard
                    image={item.image}
                    collectionName={item.contractName}
                    name={item.name}
                    tokenId={item.tokenId}
                    status={item.status}
                    address={item.nftAddress}
                    key={index}
                    index={index}
                    currNft={item}
                    profileNfts={filteredNfts}
                    setFilteredNfts={setFilteredNfts}
                    setNftStaesOnSelect={setNftStaesOnSelect}
                  />
                </Box>
              ))}
            </Box>
          ) : (
            <TableView
              data={filteredNfts}
              setFilteredNfts={setFilteredNfts}
              setNftStaesOnSelect={setNftStaesOnSelect}
            />
          )
        ) : searchShow && filteredNfts.length === 0 ? (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <NoData text="No Nft to show!" />
          </Box>
        ) : profileNfts.length > 0 ? (
          view === "gallery" ? (
            <Box {...NftBoxProps()}>
              {profileNfts.map((item, index) => (
                <Box gridColumn="span 5" gridRow="span 3">
                  <NftCard
                    image={item.image}
                    collectionName={item.contractName}
                    name={item.name}
                    tokenId={item.tokenId}
                    status={item.status}
                    address={item.nftAddress}
                    key={index}
                    index={index}
                    currNft={item}
                    profileNfts={profileNfts}
                    setNftStaesOnSelect={setNftStaesOnSelect}
                    forScholar={true}
                  />
                </Box>
              ))}
            </Box>
          ) : (
            <TableView
              data={profileNfts}
              setNftStaesOnSelect={setNftStaesOnSelect}
            />
          )
        ) : (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <NoData text="No Nft to show!" />
          </Box>
        )}

        <Box
          display="flex"
          flexDirection="row"
          width="97%"
          marginBottom="10px"
          marginTop="50px"
          alignItems={"center"}
          justifyContent={"center"}
          pl={1}
          visibility={currStatus === BORROWED ? "hidden" : "visible"}
        >
          <StyledButton
            onClick={() => {
              if (currStatus === IN_INVENTORY) {
                setStep(1);
                setOperation("bulk-transfer");
              } else if (currStatus === CLAIMABLE) {
                onClaim();
              }
            }}
            variant="outlined"
            colors={colors}
            disabled={selectedNft.length === 0}
          >
            {currStatus === IN_INVENTORY ? "Send" : "Claim"}
          </StyledButton>
        </Box>
      </Box>
    );
  }

  if (currStatus === CLAIMABLE) {
    return (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          paddingBottom: "20px",
        }}
        gap="10px"
      >
        <SearchAndView view={view} setView={setView} />

        <StatusTab currStatus={currStatus} setCurrStatus={setCurrStatus} />

        {currStatus === IN_INVENTORY && (
          <img
            src={leftArrow}
            alt="left arrow"
            style={{ margin: "15px", cursor: "pointer" }}
            onClick={() => setInnerStepper(0)}
          />
        )}

        {profileNfts.length > 0 ? (
          view === "gallery" ? (
            <Box {...NftBoxProps()}>
              {profileNfts.map((item, index) => (
                <Box gridColumn="span 5" gridRow="span 3">
                  <NftCard
                    image={item.image}
                    collectionName={item.contractName}
                    name={item.name}
                    tokenId={item.tokenId}
                    status={item.status}
                    address={item.nftAddress}
                    key={index}
                    index={index}
                    currNft={item}
                    profileNfts={profileNfts}
                    setNftStaesOnSelect={setNftStaesOnSelect}
                    forScholar={true}
                  />
                </Box>
              ))}
            </Box>
          ) : (
            <TableView
              data={profileNfts}
              setNftStaesOnSelect={setNftStaesOnSelect}
            />
          )
        ) : (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <NoData text="No Nft to show!" />
          </Box>
        )}

        <Box
          display="flex"
          flexDirection="row"
          width="97%"
          marginBottom="10px"
          marginTop="50px"
          alignItems={"center"}
          justifyContent={"center"}
          pl={1}
          visibility={currStatus === BORROWED ? "hidden" : "visible"}
        >
          <StyledButton
            onClick={() => {
              if (currStatus === IN_INVENTORY) {
                setStep(1);
                setOperation("bulk-transfer");
              } else if (currStatus === CLAIMABLE) {
                onClaim();
              }
            }}
            variant="outlined"
            colors={colors}
            disabled={selectedNft.length === 0}
          >
            {currStatus === IN_INVENTORY ? "Send" : "Claim"}
          </StyledButton>
        </Box>
      </Box>
    );
  }
};
